// Порт референсного VideoForm/Timecodes/timeUtils.js

/** Секунды → строка времени MM:SS или HH:MM:SS. */
export function secondsToTimeString(seconds: number, useHours = false): string {
  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (useHours || hours > 0) {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
}

/** Строка времени → секунды (терпит недозаполненные и «_» из маски). */
export function timeStringToSeconds(
  timeString: string,
  useHours = false
): number {
  if (!timeString || timeString.replace(/[_:]/g, "").trim() === "") return 0;

  const cleaned = timeString.replace(/[_]/g, "0").trim();
  const parts = cleaned.split(":").map((part) => parseInt(part, 10) || 0);

  if (useHours) {
    if (parts.length >= 3) {
      const [hours = 0, minutes = 0, seconds = 0] = parts;
      return hours * 3600 + minutes * 60 + seconds;
    }
    if (parts.length === 2) {
      const [hours = 0, minutes = 0] = parts;
      return hours * 3600 + minutes * 60;
    }
    return (parts[0] ?? 0) * 3600;
  }

  if (parts.length >= 2) {
    const [minutes = 0, seconds = 0] = parts;
    return minutes * 60 + seconds;
  }
  if (parts.length === 1) {
    return (parts[0] ?? 0) * 60;
  }
  return 0;
}

/** Время валидно, если пустое или не превышает длительность видео. */
export function isTimeValid(
  timeString: string,
  videoDuration: number,
  useHours = false
): boolean {
  if (!timeString || timeString.replace(/[_:]/g, "").trim() === "") {
    return true;
  }

  const seconds = timeStringToSeconds(timeString, useHours);
  return videoDuration > 0 ? seconds <= videoDuration : true;
}
